import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { ShareTable, QueryFilter, QUERY_FILTER_BOOKSTORE } from '../../../shared';
import { Paper, Typography, LinearProgress, Grid } from '@material-ui/core';
import { GetCacheIfExists, SetDataToSession, HasNoFilterAppliedBookstoreShare } from '../../../shared/cache/Cache';

// tslint:disable-next-line:no-empty-interface
export interface IBookstoreStoreShareProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IBookstoreStoreShareState {
    isUpdate: boolean,
    customFilter: {
        isChart: boolean
    },

}

const PUBLISHER_STORE_SHARE = gql`
query bookstoreStoreShare($customFilter: BookstoreCustomFilter) {
    bookstoreStoreShare(bookstoreCustomFilter: $customFilter) {
        name,
        value
    },
}
`;

const dataFilled = (data: any) => {
    return data && data.bookstoreStoreShare && !!data.bookstoreStoreShare.length
}

export class BookstoreStoreShare extends React.Component<IBookstoreStoreShareProps, IBookstoreStoreShareState> {
    constructor(props: IBookstoreStoreShareProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
            isUpdate: false,
        }
    }

    public render() {
        const jsonFilter = {
          "customFilter": {
            "isChart": this.state.customFilter.isChart,
          }
        };

        return (
            <Query query={QUERY_FILTER_BOOKSTORE} notifyOnNetworkStatusChange={true}  >
                {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {

                    const storyFilters = QueryFilter.getBookstoreStoryFilter(clientC);

                    if (storyFilters != null && storyFilters !== undefined && storyFilters.length >= 1) {
                        return null;
                    }

                    let dataCache = GetCacheIfExists('bookstore-data');
                    const hasNoFilterAppliedBookstore = HasNoFilterAppliedBookstoreShare(clientC);

                    if( hasNoFilterAppliedBookstore && dataCache != null && dataCache.bookstoreStoreShare != null ) {
                        return this.dataToRend(dataCache, false);
                    } else {
                        return (
                            <Query query={PUBLISHER_STORE_SHARE} variables={QueryFilter.getFilterBookstore(clientC, jsonFilter, ['bookstores'])}>
                                {({ loading, error, data, client}) => {

                                    if ( hasNoFilterAppliedBookstore && data != null && data.bookstoreStoreShare != null ) {
                                        if(dataCache != null && dataCache !== undefined) {
                                            dataCache.bookstoreStoreShare = data.bookstoreStoreShare;
                                        } else {
                                            dataCache = data;
                                        }
                                        SetDataToSession('bookstore-data', dataCache);
                                    }

                                    return this.dataToRend(data, loading);
                                }}
                            </Query>
                        );
                    }
                }}
            </Query>
        )
    }

    /**
     * Método utilizado para renderizar as informações do card
     * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
     */
    private dataToRend (data:any, loading:any) {
        // if (!loading && (!data || !data.bookstoreStoreShare || data.bookstoreStoreShare.length <= 1)) {
        //     return <span />;
        // }

        return (
            <Grid item={true} xs={6} md={6}>
                <Paper className="publisher-sale-block panel-block">
                    <Typography variant="headline" className="panel-title" component="title">
                        Share por Loja
                    </Typography>
                    {
                        loading
                        ?
                        <LinearProgress />
                        :
                        (
                            dataFilled(data)
                            ?
                            (<ShareTable table_main={data.bookstoreStoreShare} table_01={data.bookstoreStoreShare} table_02={data.publisherStoreMarketShare} title={"Share por Loja"} showMax={5} showFirstTable={true} />)
                            :
                            (<Typography variant="body2" className="comparative" component="p">
                                Não há informações de vendas
                            </Typography>)
                        )
                    }
                </Paper>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/bookstore/sale/store-share/BookstoreStoreShare.tsx